import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function FlagIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <path d="M405.1,240.7l-58.4-93.4l58.4-93.4c2.1-3.4,2.3-7.8,0.3-11.3c-2-3.5-5.7-5.7-9.7-5.7H121.2v-7.5c0-6.1-5-11.1-11.1-11.1s-11.1,5-11.1,11.1v452.6c0,6.1,5,11.1,11.1,11.1s11.1-5,11.1-11.1V257.7h274.4c4,0,7.8-2.2,9.7-5.7C407.3,248.5,407.2,244.1,405.1,240.7z M324.1,153.2l51.4,82.3H121.2V59.1h254.3l-51.4,82.3C321.8,144.9,321.8,149.6,324.1,153.2z" />
        </Icon>
    );
}
